import {utils} from '@wallaby-ui/core';
import {isEmpty} from 'lodash';
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';

import {AgGridFilterButton} from './AgGridFilterButton';
import styles from './AgGridFilterButtonItems.less';
import {FilterButtonConfig} from 'src/js/model/filter_button_config';

const I18N = defineMessages({
  FILTER: {
    id: 'grid.filterButtons.title',
    defaultMessage: 'Filter',
    description: 'text filter buttons span',
  },
});

interface OwnProps {
  filterButtonsConfig: FilterButtonConfig[];
  currentFilterButton?: number;
  handleItemClick: (filterButtonConfig: FilterButtonConfig) => void;
}

type Props = OwnProps;

export const AgGridFilterButtonItems: React.FC<Props> = (props) => {
  const {currentFilterButton, filterButtonsConfig, handleItemClick} = props;

  const intl = useIntl();

  return isEmpty(filterButtonsConfig) ? null : (
    <div className={styles.dlAgGridHeader} data-name={'ag-filetable-header'}>
      <span className={styles.dlAgGridHeaderLabel}>
        {utils.TranslateUtils.translate({...I18N.FILTER}, intl)}
      </span>
      {filterButtonsConfig.map((filterButtonConfig) => {
        const id = filterButtonConfig.getId();
        const isClicked = currentFilterButton === id;
        return (
          <AgGridFilterButton
            key={id}
            filterButtonConfig={filterButtonConfig}
            handleClick={handleItemClick}
            isClicked={isClicked}
          />
        );
      })}
    </div>
  );
};

AgGridFilterButtonItems.displayName = 'AgGridFilterButtonItems';
